module.exports = __webpack_public_path__ + "img/banner_rank.b810cffa.png";